import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";
import AuthModal from "./components/auth/AuthModal";
import ForgotPasswordModal from "./components/auth/ForgotPasswordModal";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import PersonDetail from "./pages/persons/PersonDetail";
import PersonList from "./pages/persons/PersonList";
import MissionList from "./pages/missions/MissionList";
import MissionDetail from "./pages/missions/MissionDetail";
import authService from "./services/authService";

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useEffect(() => {
    // Check of er al een user in localStorage is
    const currentUser = authService.getCurrentUser();
    if (currentUser) {
      setIsAuthenticated(true);
      setUser(currentUser);
    } else {
      setIsAuthenticated(false);
      setUser(null);
    }
    setLoading(false);
  }, []);

  const handleLoginSuccess = (account) => {
    console.log('Login success! Account:', account);
    console.log('PersonId:', account?.personId);
    setIsAuthenticated(true);
    setUser(account);
  };

  const handleLogout = () => {
    authService.logout();
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return null; // of een loading spinner
  }

  return (
    <BrowserRouter>
      {!isAuthenticated && !showForgotPassword && (
        <AuthModal 
          onLoginSuccess={handleLoginSuccess}
          onForgotPasswordClick={() => setShowForgotPassword(true)}
        />
      )}

      {!isAuthenticated && showForgotPassword && (
        <ForgotPasswordModal 
          onBack={() => setShowForgotPassword(false)}
        />
      )}

      {isAuthenticated && user && (
        <AppLayout onLogout={handleLogout} user={user}>
          <Routes>
            <Route path="/" element={<PersonDetail id={user.personId} isDashboard={true} />} />
            <Route path="/missions" element={<MissionList />} />
            <Route path="/missions/:id" element={<MissionDetail />} />
            <Route path="/persons" element={<PersonList />} />
          </Routes>
        </AppLayout>
      )}

      <Routes>
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </Routes>
    </BrowserRouter>
  );
}

